import React, { FC, useMemo } from 'react'
import { StyledOrderSummary, OrderItem, OrderItemType } from '.'

type Props = {
  items: OrderItemType[];
  discountAmount?: number;
  discountType?: string;
}

const OrderSummary: FC<Props> = ({ items, discountAmount = 0, discountType }) => {
  const getTotal = () => {
    const total = items.reduce((total, item) => {
      return total + item.price
    }, 0)

    return Math.max(0, total - discountAmount)
  }

  const discountDescription = useMemo(() => {
    switch (discountType) {
      case 'month-trial-discount':
        return 'First month discount'
      case 'year-trial-discount':
        return 'First year discount'
      case 'promo-code':
        return 'Promo code'
      default:
        return null
    }
  }, [discountType])

  return (
    <StyledOrderSummary>
      <div className="item-list">
        {items.map((item, index) => {
          return <OrderItem item={item} key={index} discountApplied={discountAmount > 0} />
        })}
        {discountAmount > 0 && (
          <div className="discount-details">
            <p className="discount-description">{discountDescription}</p>
            <p className="total-discount">
              <span className="minus-symbol">-</span>${discountAmount}
            </p>
          </div>
        )}
      </div>
      <div className="order-total">
        <span className="total-label">TOTAL</span>
        <span className="total-amount">${getTotal()} USD</span>
      </div>
    </StyledOrderSummary>
  )
}

export default OrderSummary
